// ============================================================================
// FSA NOTES ENDPOINTS  (FSA-2.2)
// ============================================================================

import { buildEndpointWithParams } from '../base.endpoints';
import type { ID } from '../../types';

const BASE_PATH = '/FsaNotes';

export const fsaNotesEndpoints = {
  /** GET /api/v1/FsaNotes/by-engagement/{engId} */
  listByEngagement: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId`, { engId }),

  /** GET /api/v1/FsaNotes/by-engagement/{engId}/custom-classes (FSA-2.2 step 4b) */
  listCustomClasses: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/custom-classes`, { engId }),

  /** GET /api/v1/FsaNotes/by-engagement/{engId}/{scheduleId} */
  hydrate: (engId: ID, scheduleId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:scheduleId`, { engId, scheduleId }),

  /** PUT /api/v1/FsaNotes/by-engagement/{engId}/{scheduleId} */
  save: (engId: ID, scheduleId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:scheduleId`, { engId, scheduleId }),

  /** POST /api/v1/FsaNotes/by-engagement/{engId}/{scheduleId}/submit */
  submit: (engId: ID, scheduleId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:scheduleId/submit`, { engId, scheduleId }),

  /** POST /api/v1/FsaNotes/by-engagement/{engId}/{scheduleId}/approve */
  approve: (engId: ID, scheduleId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:scheduleId/approve`, { engId, scheduleId }),

  /** POST /api/v1/FsaNotes/by-engagement/{engId}/{scheduleId}/reopen */
  reopen: (engId: ID, scheduleId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:scheduleId/reopen`, { engId, scheduleId }),

  /** POST /api/v1/FsaNotes/by-engagement/{engId}/{scheduleId}/exclude (FSA-2.2) */
  exclude: (engId: ID, scheduleId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:scheduleId/exclude`, { engId, scheduleId }),

  /** POST /api/v1/FsaNotes/by-engagement/{engId}/{scheduleId}/include (FSA-2.2) */
  include: (engId: ID, scheduleId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:scheduleId/include`, { engId, scheduleId }),

  /** PUT /api/v1/FsaNotes/by-engagement/{engId}/{scheduleId}/note-number (FSA-2.2) */
  setNoteNumber: (engId: ID, scheduleId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:scheduleId/note-number`, { engId, scheduleId }),

  /** POST /api/v1/FsaNotes/by-engagement/{engId}/auto-number (FSA-2.2) */
  autoNumber: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/auto-number`, { engId }),

  /** POST /api/v1/FsaNotes/by-engagement/{engId}/{scheduleId}/move-to-position (FSA-2.3) */
  moveToPosition: (engId: ID, scheduleId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:scheduleId/move-to-position`, { engId, scheduleId }),

  /** POST /api/v1/FsaNotes/by-engagement/{engId}/{scheduleId}/import-from-prior-year (FSA-2.3 Roll Forward) */
  importFromPriorYear: (engId: ID, scheduleId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:scheduleId/import-from-prior-year`, { engId, scheduleId }),
} as const;

export default fsaNotesEndpoints;
